import { useEffect } from "react";
import NavigationBar from "../../../components/NavigationBar/NavigationBar";
import PortalApplicationContent from "../../../components/PortalApplicationContent/PortalApplicationContent";
import Footer from "../../../components/Footer/Footer";
import "../JobPortal.scss";


export default function JobPortalApplication() {
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavigationBar />
      <div className="d-block bg-all" style={{height: "126px"}}/>
      <PortalApplicationContent />
      <Footer />
    </div>
  )
}